import React, { useState } from "react";
import PaymentMethodSelector from "../payment/PaymentMethodSelector";

const ArticleBoostModal = ({
  show,
  loading,
  onClose,
  onConfirm,
  prixBoost,
  formPaiement,
  setFormpaiement,
  paymentMethods,
  setPaymentMethods,
}) => {
  if (!show) return null;

  return (
    <>
      <div className="container">
        <div
          className="modal fade show d-block "
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-fullscreen"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header container border-0">
                <h5 className="modal-title">💳 Booster votre annonce</h5>
                <i
                  class="bi bi-x-circle login_icon_x"
                  role="button"
                  onClick={() => {
                    onClose();
                  }}
                ></i>
              </div>

              <div className="modal-body boost_modal_body container">
                <p>
                  Le boost augmente la visibilité de votre annonce pour
                  <strong> 1 jour</strong>.
                </p>
                <p className="text-muted">
                  Choisissez votre mode de paiement et confirmez le boost.
                </p>

                <PaymentMethodSelector
                  paymentMethods={paymentMethods}
                  setPaymentMethods={setPaymentMethods}
                  formPaiement={formPaiement}
                  setFormpaiement={setFormpaiement}
                  totalAmount={prixBoost}
                />

                <button
                  type="button"
                  className="btn_boost_confirm mt-2"
                  onClick={() => onConfirm({ paymentMethods, formPaiement })}
                  disabled={loading || !paymentMethods}
                >
                  {loading ? "Traitement..." : "Confirmer le boost (Paiement)"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Backdrop */}
        <div className="modal-backdrop fade show"></div>
      </div>
    </>
  );
};

export default ArticleBoostModal;
